var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home"}},_vm._l((_vm.games),function(game){return _c('GameSlide',{attrs:{"game":game}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }